import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import blogPosts from "../../data/blogs.json";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import matter from "gray-matter";
import { Buffer } from "buffer";
import { formatDate } from "../../utils/formatDate";
window.Buffer = Buffer;

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState("");

  //const post = blogPosts.find((post) => post.id === parseInt(id));

  const post = blogPosts.find((post) => post.id === id); // Match the `id` from URL

  useEffect(() => {
    console.log("Looking for post with ID:", id);

    if (!post) {
      console.error("Post not found in blogs.json for ID:", id);
      return;
    }

    // Dynamic import the Markdown file based on the ID
    import(`../../data/blogPosts/${id}.md`)
      .then((res) => {
        console.log("Markdown file loaded successfully:", res.default);
        return fetch(res.default);
      })
      .then((r) => r.text())
      .then((text) => {
        const { content } = matter(text);
        setContent(content);
      })
      .catch((err) => {
        console.error("Error loading the Markdown file:", err);
      });
  }, [id, post]);

  if (!post) {
    return <div className="error-message">Post not found!</div>;
  }

  return (
    <div className="full-screen-generic">
      <div className="about">
        <PageHeader title={post.title} handleClick={() => navigate(-1)} />

        <div className="blog-content">
          <img src={post.image} alt={post.title} className="blog-thumbnail" />
          <div className="blog-meta">
            <span className="blog-date">{formatDate(post.date)}</span>
            <span className="blog-reading-time">{post.readingTime}</span>
          </div>
          <div className="blog-tags">
            {post.categories.map((cat, i) => (
              <span key={i} className="tag">
                {cat}
              </span>
            ))}
          </div>
          <ReactMarkdown remarkPlugins={[remarkGfm]} className="markdown-body">
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;

// CSS Styling
const styles = `
.blog-detail-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 20px;
  max-width: 800px;
  margin: auto;
  color: #fff;
}

.blog-content {
  font-size: 1.2rem;
  line-height: 1.6;
  color: #ddd;
}

 .blog-reading-time {
    font-size: 1rem;
    color: #bbb;
  }

  .blog-tags {
  margin-top: 5px;
  margin-bottom: 5px;
}

.blog-date {
  font-size: 0.9rem;
  color: #bbb;
  display: block;
  margin-bottom: 5px;
}

.error-message {
  text-align: center;
  font-size: 1.5rem;
  color: #ff6b6b;
  margin-top: 50px;
}

.markdown-body p {
  margin-bottom: 1em; /* Adjust paragraph spacing */
  line-height: 1.6;
}

.markdown-body h2 {
  margin-top: 0.5em; /* Adjust heading spacing */
  margin-bottom: 0.5em;
}

.markdown-body ul, .markdown-body ol {
    margin-left: 1.5em;
    margin-bottom: 1em;
}

.markdown-body li {
    margin-bottom: 0.5em;
}

.markdown-body blockquote {
    border-left: 3px solid #ddd;
    padding-left: 1em;
    margin: 1em 0;
}

.markdown-body code {
    background-color: #282c34;
    color: #abb2bf;
    padding: 2px 5px;
    border-radius: 3px;
}

.markdown-body pre code {
    display: block;
    padding: 1em;
    overflow-x: auto;
}
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
